import * as React from "react";
const SvgFiRrRankingStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ranking-star_svg__a)">
      <path
        fill="#062147"
        d="M20.5 16H17v-3.5c0-1.93-1.57-3.5-3.5-3.5h-3C8.57 9 7 10.57 7 12.5v.5H3.5C1.57 13 0 14.57 0 16.5v4C0 22.43 1.57 24 3.5 24h17c1.93 0 3.5-1.57 3.5-3.5v-1c0-1.93-1.57-3.5-3.5-3.5M9 12.5c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5V22H9zm-7 8v-4c0-.827.673-1.5 1.5-1.5H7v7H3.5c-.827 0-1.5-.673-1.5-1.5m20 0c0 .827-.673 1.5-1.5 1.5H17v-4h3.5c.827 0 1.5.673 1.5 1.5zM8.041 2.857a.67.67 0 0 1 .626-.437h2.001l.708-1.987a.666.666 0 0 1 1.25 0l.708 1.987h2.001a.666.666 0 0 1 .429 1.177l-1.577 1.285.652 1.987a.666.666 0 0 1-.997.769l-1.836-1.196-1.805 1.208a.668.668 0 0 1-1.007-.754l.627-2.011-1.585-1.29a.67.67 0 0 1-.195-.738"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ranking-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRankingStar;
